import React from 'react';

const CrewDefault = (props) => {

    return (<React.Fragment>
        <div>
        CrewDefault
        </div>
    </React.Fragment>)
};

export default CrewDefault;